import { i18nTranslationHelper } from '@/i18n'

export namespace EnrollmentStatus {
  const t = i18nTranslationHelper.getTEnums

  export class Enum {
    public static readonly PENDING = new Enum(
      -1,
      'PENDING',
      t('authorizationsStatus.PENDING.display'),
      'info'
    )

    public static readonly LEADER_REJECTED = new Enum(
      0,
      'LEADER_REJECTED',
      t('authorizationsStatus.LEADER_REJECTED.display'),
      'error'
    )

    public static readonly WAITING_ENROLLMENT = new Enum(
      1,
      'WAITING_ENROLLMENT',
      t('authorizationsStatus.WAITING_ENROLLMENT.display'),
      'info'
    )

    public static readonly ERROR_ENROLLMENT = new Enum(
      2,
      'ERROR_ENROLLMENT',
      t('authorizationsStatus.ERROR_ENROLLMENT.display'),
      'error'
    )

    public static readonly ONGOING = new Enum(
      3,
      'ONGOING',
      t('authorizationsStatus.ONGOING.display'),
      'success'
    )

    public static readonly ABANDONED = new Enum(
      4,
      'ABANDONED',
      t('authorizationsStatus.CANCELED.display'),
      'error'
    )

    public static readonly CANCELED = new Enum(
      4,
      'CANCELED',
      t('authorizationsStatus.CANCELED.display'),
      'error'
    )

    public static readonly FINISHED = new Enum(
      5,
      'FINISHED',
      t('authorizationsStatus.FINISHED.display'),
      'success'
    )

    public static readonly EXPIRED = new Enum(
      9,
      'EXPIRED',
      t('authorizationsStatus.EXPIRED.display'),
      'error'
    )

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly displayText: string,
      public readonly type:
        | 'default'
        | 'primary'
        | 'secondary'
        | 'info'
        | 'error'
        | 'warning'
        | 'success'
    ) {}
  }

  export const getById = (id: number): Enum => {
    return Object.values(EnrollmentStatus.Enum).find(category => category.id === id)
  }

  export const getByName = (name: string): Enum => {
    return Object.values(EnrollmentStatus.Enum).find(category => category.name === name)
  }
}

export enum EnrollmentStatusTab {
  WAITING_HR = 'WAITING_HR',
  WAITING_USER = 'WAITING_USER',
  FINISHED = 'FINISHED'
}

export enum EnrollmentStepStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  DISABLED = 'DISABLED',
  ERROR = 'ERROR'
}

export enum EnrollmentStepTypeEnum {
  REQUESTED = 'REQUESTED',
  LEADER_APPROVAL = 'LEADER_APPROVAL',
  WAITING_ENROLLMENT = 'WAITING_ENROLLMENT',
  ONGOING = 'ONGOING',
  FINISHED = 'FINISHED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED'
}

export enum EnrollmentCanceledByEnum {
  USER = 'USER',
  ADMIN = 'ADMIN',
  PARTNER = 'PARTNER'
}
